module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "titlepage",
      "id": "bk"
    }
  }, [_c('h1', {
    staticClass: "bk"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ii",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "iii",
      "id": "piii",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SOPHISTRY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("POLITICAL")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PHILOSOPHY")])]), _vm._v(" "), _c('h1', {
    staticClass: "bk1"
  }, [_vm._v("Protagoras’ Challenge to Socrates")]), _vm._v(" "), _c('p', {
    staticClass: "bkau"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "piii"
    }
  }), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ROBERT")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("C.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BARTLETT")])]), _vm._v(" "), _c('p', {
    staticClass: "bkpub"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("UNIVERSITY")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("CHICAGO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("PRESS")])]), _vm._v(" "), _c('p', {
    staticClass: "bkpub1"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("CHICAGO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LONDON")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1240fa24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Bartlett-SOPHISTRY-pbk-update-0003.vue
// module id = 60
// module chunks = 0